import role from 'plugins/i18n/entity/role.en.ts'
import building from 'plugins/i18n/entity/building.en.ts'
import unit from 'plugins/i18n/entity/unit.en.ts'

const permission = {
	name: '',
	icon: '',
	fields: {
		role: {
			hp_id: 'Role',
		},
		building: {
			hp_id: 'Building',
		},
		unit: {
			hp_id: 'Unit',
		},
		started_at: '@:common.startedAt',
		ended_at: '@:common.endedAt',
	},
}

export default permission
